import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="Diğer sporcu yorumları" className="bg-warm" data-id="element-144" data-mp="20fowudtw93h2">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "17px",
      paddingBottom: "11px"
    }} data-id="element-145" data-mp="2599z4i2isjm2">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-146" data-mp="2a9xnevzd6mcl">
          Sistemi kullanmaya başlamış sporcular
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-147" data-mp="1hjpdtsiw9a9m">
          {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.05} data-id="element-148" data-mp="1mgz1b2mq3but" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}